import styled from 'styled-components';

// MPH-1507: the dialog's visible title, exposed as a heading. It takes the header's own typography
// (Title5 in BasicModalHeader, Title4 in BasicModalHeaderV2), so it looks exactly like the bare text it wraps.
// Opt in per dialog: the dialog's content headings must start at h3 below it.
const ModalHeaderTitle = styled.h2`
  margin: 0;
  font: inherit;
  color: inherit;
  min-width: 0;
`;

export default ModalHeaderTitle;
